(function () {
  const clean = value => String(value || '').trim().toUpperCase().replace(/["“”]/g, '').replace(/×/g, 'X').replace(/\s+/g, '').replace(/^LT/, '');
  const decimal = value => String(Number(value));
  function parse(value) {
    const raw = clean(value);
    let match = raw.match(/^(\d{3})[\/X-]?(\d{2})(?:ZR|R|[\/X-])?(\d{2}(?:\.5)?)(?:C|LT)?$/);
    if (match) {
      const [, width, profile, rim] = match;
      if (+width < 100 || +width > 495 || +profile < 15 || +profile > 95 || +rim < 10 || +rim > 30) return null;
      return { size: `${width}/${profile}R${rim}`, parameter: `${width}-${profile}R${rim}` };
    }
    match = raw.match(/^(\d{3})R(\d{2}(?:\.5)?)(?:C|LT)?$/);
    if (match && +match[1] >= 100 && +match[1] <= 495 && +match[2] >= 10 && +match[2] <= 30) {
      return { size: `${match[1]}R${match[2]}`, parameter: `${match[1]}R${match[2]}` };
    }
    match = raw.match(/^(\d{2}(?:\.\d{1,2})?)X(\d{1,2}(?:\.\d{1,2})?)(?:R|-)?(\d{2}(?:\.5)?)(?:LT)?$/);
    if (match && +match[1] >= 20 && +match[1] <= 50 && +match[2] >= 5 && +match[2] <= 20 && +match[3] >= 10 && +match[3] <= 30) {
      const size = `${decimal(match[1])}x${Number(match[2]).toFixed(2)}R${match[3]}`;
      return { size, parameter: size };
    }
    match = raw.match(/^(\d{1,2}\.\d{1,2})(?:R|-)(\d{2}(?:\.5)?)(?:C|LT)?$/);
    if (match && +match[1] >= 4 && +match[1] <= 20 && +match[2] >= 10 && +match[2] <= 30) {
      const size = `${Number(match[1]).toFixed(2)}R${match[2]}`;
      return { size, parameter: size };
    }
    return null;
  }
  function url(value) {
    const parsed = parse(value);
    if (!parsed) return null;
    const params = new URLSearchParams({q: `"${parsed.size}"`, type: 'product', tyre_size: parsed.parameter, sort_by: 'price-ascending'});
    return '/search?' + params.toString();
  }
  window.TSTyreSizeSearch = { parse, url };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.matches('[data-tyre-finder]')) return;
    if (!form.matches('[data-exact-size-search], form[action*="/search"]')) return;
    const input = form.querySelector('[name="q"]');
    if (!input) return;
    const route = url(input.value);
    if (route) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(route);
    } else if (form.matches('[data-exact-size-search]')) {
      event.preventDefault();
      input.setCustomValidity('Enter the full size, for example 33x12.50R15, 195R15 or 7.50R16.');
      input.reportValidity();
    }
  }, true);
  document.addEventListener('input', event => {
    if (event.target.matches('[data-exact-size-search] [name="q"]')) event.target.setCustomValidity('');
  });
  const params = new URLSearchParams(window.location.search);
  const legacy = window.location.pathname.match(/^\/collections\/[^/]+\/size-(\d{3})-(\d{2})r(\d{2}(?:\.5)?)\/?$/i);
  if (legacy) window.location.replace(url(`${legacy[1]}/${legacy[2]}R${legacy[3]}`));
  if (window.location.pathname === '/search' && !params.get('tyre_size') && parse(params.get('q'))) window.location.replace(url(params.get('q')));
})();
